import { ImageProps } from 'next/dist/client/image';
import { useWindowSizing } from '@app/hooks/useSizeWindow';
import Image from 'next/image';
import classNames from 'classnames';

import styles from './BrandBlock.module.scss';

export interface BrandBlock extends ImageProps {
  name: string;
  src: string;
  href: string;
}

export const BrandBlock = ({ name, src, href, className, ...props }: BrandBlock) => {
  const isMobile = useWindowSizing(770);

  if (!src) {
    return null;
  }

  const liningBrand = isMobile
    ? {
        backgroundColor: '#FFFFFFB3',
        borderRadius: '2px',
      }
    : {};

  return (
    <div className={classNames(styles.WrapperBrand, className)} style={liningBrand}>
      <a href={href || ''} data-testid="product-brand-link">
        <Image src={src} alt={name} {...props} />
      </a>
    </div>
  );
};
